import { ComponentRoute } from '@/classes'

const ItemRoutes = {
  ItemListView: new ComponentRoute('/items', 'ItemListView'),
  ItemView: new ComponentRoute('/items/:id', 'ItemView'),
  ItemDetail: new ComponentRoute('/items/:id/:source', 'ItemDetail')
}

export default ItemRoutes
